import { useState } from 'react';
import text_lang from '../translations/translations';

function Form({handleSubmit}) {
    const [text,setText] = useState(text_lang)
  
    const onSubmit =(e) =>{
      e.preventDefault()
      handleSubmit()
    }
    return (
      <div className="form">
        <form  action="https://formsubmit.co/media@latin-plug.com" method="POST">

        <div className="form-group container">
        <p>*{text.credential_disclaimer}</p>
  
            <label htmlFor="Nombre">{text.corresponsal_name} <br/><sup>({text.id_disclaimer})</sup>  </label><br/>
            <input className="form-control" type="text" id="nombre_corresponsal" name="Nombre" placeholder={text.name}/><br/>
            <label htmlFor="Email">{text.email_correspondent} </label><br/>
            <input className="form-control" type="text" id="html" name="Email" placeholder={text.email_placeholder}/><br/>
            <label htmlFor="Nombre de camarografo">{text.cameraman_name}<br/><sup>({text.id_disclaimer})</sup>  </label><br/>
            <input className="form-control" type="text" id="nombre_camarografo" name="Nombre de camarografo" placeholder={text.name}/><br/>
            <label htmlFor="Email">{text.email_cameraman} </label><br/>
            <input className="form-control" type="text" id="html" name="Email" placeholder={text.email_placeholder}/><br/>
            <label htmlFor="Nombre de la plataforma">{text.platform_name} </label><br/>
            <input className="form-control" type="text" id="html" name="Nombre de la plataforma" placeholder={text.name}/><br/>
            <label htmlFor="Pagina web de la plataforma">{text.platform_website}</label><br/>
            <input className="form-control" type="text" id="html" name="Pagina web de la plataforma" placeholder={text.name}/><br/>
  
            <label>{text.social_media}<br/><sup>({text.leave_blank})</sup> </label><br/>
            <div>
              <span>
              <label htmlFor="Instagram">Instagram </label>
              <input className="form-control w-25" type="text" id="html" name="Instagram" placeholder={text.url}/>
              </span>
              <span>
              <label htmlFor="Youtube">Youtube </label>
              <input className="form-control w-25" type="text" id="html" name="Youtube" placeholder={text.url}/>
              </span>
                          <span>
              <label htmlFor="Tiktok">Tiktok </label>
              <input className="form-control w-25" type="text" id="html" name="Tiktok" placeholder={text.url}/>
              </span>
                          <span>
              <label htmlFor="Facebook">Facebook </label>
              <input className="form-control w-25" type="text" id="html" name="Facebook" placeholder={text.url}/>
              </span>
            </div>
            <label htmlFor="Cuantas credenciales">{text.how_many_credentials} </label><br/>
            <input className="form-control" type="text" id="html" name="Cuantas credenciales" placeholder={text.name}/><br/>
            <label htmlFor="Numero de telefono">{text.phone_number}<br/><sup>({text.phone_country_code})</sup></label><br/>
            <input className="form-control" type="text" id="html" name="Numero de telefono" placeholder={text.name}/><br/>
            <div>
            <input className="form-control" type="submit" value="Enviar"/>
            </div>
  
        </div>
        </form>
      </div>
    );
  }

  export default Form